'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import ParametresContent from './components/ParametresContent';

export default function ParametresPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/parametres">
        <ParametresContent />
      </AppLayout>
    </RouteGuard>
  );
}
